export default class NetworkError extends Error {
  constructor({ message, name }: Error) {
    super(message);
    this.name = name;
    this.message = message;
    this.stack = new Error().stack;
  }
}
